import * as React from "react";
import {DataBaseComponent} from "../DataBaseComponent/DataBaseComponent";
import {PagingDataTable} from "../PagingDataTable/PagingDataTable";
import {EventResource} from "../../client/resources/eventResource";
import DateFormatter from "../../utils/DateFormatter/DateFormatter";
import {EventFormatter} from "../EventFormatter/EventFormatter";
import {ResourceCollection} from "client/resources/resourceCollection";
import {repository} from "clientInstance";
import {Permission} from "client/resources/permission";
import {PermissionCheck} from "components/PermissionCheck";
import { Callout, CalloutType } from "components/Callout/Callout";
import ExternalLink from "components/Navigation/ExternalLink/ExternalLink";
import {ActionButton, ActionButtonType} from "components/Button";
import {AuditEvent} from "areas/configuration/components/AuditLayout/AuditLayout";
import EventDetails from "components/EventDetails";
import TimeFromNowLabel from "components/TimeLabels/TimeFromNowLabel";
import styles = require("./style.less");

class EventListingDataTable extends PagingDataTable<AuditEvent> {}

interface EventListingProps {
    data: ResourceCollection<EventResource>;
    regarding: string[];
    noDataMessage?: string;
}

export default class EventListing extends DataBaseComponent<EventListingProps, any> {
    constructor(props: EventListingProps) {
        super(props);
        this.state = {
            data: null
        };
    }

    render() {
        const initialData = this.state.data ? this.state.data : this.props.data;
        return <div>
            <PermissionCheck permission={Permission.EventView} wildcard={true} alternate={
                <Callout type={CalloutType.Information}>
                    The {Permission.EventView} permission is required to view results here.
                </Callout>}>
                {initialData
                ? <EventListingDataTable
                    initialData={initialData}
                    onRow={(item: any) => this.buildAuditRow(item)}
                    headerColumns={["When", "Who", "What"]}
                    headerColumnClassNames={[styles.headerColumnOccurredDate, styles.headerColumnFixedWidth, null]}
                    onEmpty={this.handleOnEmpty}
                    showPagingInNumberedStyle={true}
                    onPageSelected={async (skip: number, p: number) => {
                        const result = await repository.Events.list({regarding: this.props.regarding, skip});
                        this.setState({data: result});
                    }}
                />
                : <div>{this.props.noDataMessage || "There's no data to show."}</div>}
            </PermissionCheck>
        </div>;
    }

    private buildAuditRow(event: AuditEvent) {
        return [
            <div>
                <TimeFromNowLabel time={event.Occurred} useShortDateFormat={false} />
            </div>,
            <div title={event.IdentityEstablishedWith}>
                {event.Username}
            </div>,
            <div>
                <EventFormatter event={event} />
                {event.Details &&
                <ActionButton type={ActionButtonType.Ternary}
                    label={event.detailsVisible ? "hide details" : "show details"}
                    onClick={() => this.handleShowHideDetails(event)}/>}
                {event.Details && event.detailsVisible && <EventDetails eventDetails={event.Details} />}
            </div>
        ];
    }

    private handleOnEmpty = () => {
        return (
            <div>No events found, or <ExternalLink href="UserRoles">your permissions</ExternalLink> reduced what you can see.</div>
        );
    }

    private handleShowHideDetails = (event: AuditEvent) => {
        event.detailsVisible = !event.detailsVisible;
        this.setState({});
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/EventListing/EventListing.tsx